import {useRef} from 'react'
import {onlyIf} from '../../store.js'
import {currentDropdownSelector} from '../../redux/selectors/ui/index.js'
import TextInput from './TextInput.js'
import Zropdown, {useZropdownElement} from './Zropdown.js'
import className from '../className.js'
import Checkbox from './Checkbox.js'

export const FILTER_SELECT_ALL = 'filter_select_all'

export function SelectAllDropdownItem({
  option,
  selectedList,
  isFocused,
  onSelect,
}) {
  const ref = useRef()
  useZropdownElement({ref, isSelected: isFocused})

  const selectedCount = selectedList.length
  const selected = selectedCount > 0
  const indeterminate =
    option.entity.length !== selectedCount && selectedCount !== 0

  return (
    <li
      ref={ref}
      className="list__item list__item--dropdown list__item--dropdown-header list__item--dropdown-header-pkg-type"
    >
      <span
        className={className`label--selectable label--selectable-pt-pb-0 flex--justify-nowrap margin-bottom-0 ${{
          'list__link--dropdown-arrow-focus': isFocused,
        }}`}
      >
        <label
          className="flex--justify-nowrap flex-grow flex--jc-left mw-unset align-items-center  margin-bottom-0"
          htmlFor="shippers_filter_select_all"
          data-dropdown-prevent-close
        >
          <span>
            <Checkbox
              mode="fancy"
              className="fs-00 v-align-middle"
              id="shippers_filter_select_all"
              checked={selected}
              indeterminate={indeterminate}
              onClick={() => onSelect(option)}
            />
          </span>
          <span className="label--selectable__text lh-sm margin-left-10">
            Select {selected && !indeterminate ? 'None' : 'All'}
          </span>
        </label>
      </span>
    </li>
  )
}

/**
 * A Zropdown component with a builtin filter input
 *
 * @param {Object} props
 * @param {String} props.dropdown
 * @param {Object} props.form
 * @param {String} props.form.text
 * @param {Function} props.onChangeInternal
 * @param {Function} [props.onConfirm]
 * @param {Function} [props.onUp]
 * @param {Function} [props.onDown]
 * @param {Function} [props.onBlur]
 * @param {String} [props.placeholder]
 * @param {String} [props.dropdownClassName]
 * @param {Object} props.parentRef
 * @param {React.ReactNode} [props.children]
 * @param {React.ReactNode} [props.additionalHeader]
 * @param {React.ReactNode} [props.footer]
 * @returns {React.ReactNode}
 */
function FilterDropdown({
  dropdown,
  form,
  onChangeInternal,
  onConfirm,
  onUp,
  onDown,
  onBlur,
  placeholder,
  parentRef,
  children,
  additionalHeader,
  footer,
  dropdownClassName,
}) {
  return (
    <Zropdown
      dropdown={dropdown}
      dropdownClassName={dropdownClassName}
      parentRef={parentRef}
      onConfirm={onConfirm}
      onUp={onUp}
      onDown={onDown}
      header={
        <>
          <div className="wrap--text-input--dropdown-with-filter">
            <TextInput
              value={form.text}
              placeholder={placeholder}
              onChange={(value) => onChangeInternal(value)}
              onBlur={(event) => onBlur && onBlur(event)}
              autoFocus
              data-dropdown-prevent-close
            />
          </div>
          {additionalHeader}
        </>
      }
      footer={footer}
    >
      {children}
    </Zropdown>
  )
}

export default onlyIf(
  FilterDropdown,
  (state, {dropdown}) => dropdown === currentDropdownSelector(state),
)
